interface AddressObject {
    country?: string | null
    city?: string | null
    postalCode?: string | number | null | undefined
    address1?: string | null
    address2?: string | null
}

function getAddressStringFromObject(address?: AddressObject | null): string {
    if (!address || typeof address !== 'object') {
        return ''
    }
    const parts = [address.address1, address.address2, address.postalCode, address.city, address.country].filter(
        (part): part is string => typeof part === 'string' && part.trim().length > 0
    )

    return parts.join(', ')
}

export default getAddressStringFromObject
